﻿import { expressQuerySelector } from "../../common/html";

export function createFlipBook(flipbookElement: HTMLElement) {
	const pages = Array.from(flipbookElement.querySelectorAll<HTMLElement>(".technical-flipbook-leaf"));
	const maxZIndex = pages && pages.length ? pages[0].style.zIndex : 0; // always shown on page first => max z-index
	const prevButton = expressQuerySelector(flipbookElement, ".technical-flipbook-previous", true);
	const nextButton = expressQuerySelector(flipbookElement, ".technical-flipbook-next", true);

	const flipbookPage = (next: boolean) => {
		const filterdList = next
			? pages.filter((x) => !x.classList.contains("m-flip-book__leaf--flipped"))
			: pages.filter((x) => x.classList.contains("m-flip-book__leaf--flipped")).reverse();
		const pageToTurn = filterdList[0];
		if (!pageToTurn) return;

		pageToTurn.classList.toggle("m-flip-book__leaf--flipped", next);

		const nextPage = next ? filterdList[1] : (pageToTurn.nextElementSibling as HTMLElement);
		if (nextPage) nextPage.style.zIndex = `${next ? maxZIndex : nextPage.dataset.originalindex}`;

		nextButton.classList.toggle("a-button--disabled", next && filterdList.length <= 1);
		prevButton.classList.toggle("a-button--disabled", !next && filterdList.length <= 1);
	};

	nextButton.addEventListener(
		"click",
		() => !nextButton.classList.contains("a-button--disabled") && flipbookPage(true),
	);
	prevButton.addEventListener(
		"click",
		() => !prevButton.classList.contains("a-button--disabled") && flipbookPage(false),
	);

	return {
		next: () => flipbookPage(true),
		previous: () => flipbookPage(false),
	};
}
